<form novalidate autocomplete="kirjanpitoaineistoarkki" style="width: 100%">
  <div class="blue-background">
    <div style="margin-left: auto; margin-right: auto">
      <div class="ylapalkki">
        <app-button (click)="peruuta()" actionId="Navigoi taaksepäin" additionalClass="sulje">
          <i class="icon ion-md-arrow-back takaisin-icon"></i>
        </app-button>

        <app-lasku-ylaosan-dropparit style="width: 100%" [parent]="lomakeJaettuna" [naytaLaskunTyyppiObservable]="naytaLaskunTyyppiObservable"></app-lasku-ylaosan-dropparit>
      </div>
    </div>
  </div>

  <div style="margin-left: auto; margin-right: auto">
    <div class="infoboksi">
      @if (juurilasku.avain !== kasiteltava.avain && kasiteltava.nrotyyppi === 'h') {
        <div style="text-align: center">{{ 'lasku.hyvitys-info-teksti' | translate | async }}</div>
      }
      @if (juurilasku.avain !== kasiteltava.avain && kasiteltava.nrotyyppi !== 'h') {
        <div style="text-align: center">{{ 'lasku.muokkaus-info-teksti' | translate | async }}</div>
      }
    </div>

    <div class="lasku-container">
      <div class="vasenp">
        <div class="ylaosantiedot">
          <div class="ylaosavasen">
            <app-lasku-asiakkaan-tiedot [parent]="lomakeJaettuna" [laskunTyyppiObservable]="laskunTyyppiObservable" [laskuObservable]="laskuObservable" (asiakasMuuttui)="paivitaValittuAsiakas()" [paivitaValidaatiot]="paivitaValidaatiot"></app-lasku-asiakkaan-tiedot>
          </div>
          <div class="ylaosaoikea">
            <app-lasku-muut-tiedot [parent]="lomakeJaettuna" [laskuObservable]="laskuObservable" [paivitaValidaatiot]="paivitaValidaatiot"></app-lasku-muut-tiedot>
          </div>
        </div>

        <!-- {{fieldErrors | json}} -->

        <app-lasku-rivit [parent]="lomakeJaettuna" [laskunLiitetiedostotObservable]="laskunLiitetiedostotObservable" [laskunVastaanottajanMaaObservable]="laskunVastaanottajanMaaObservable" [laskunTyyppiObservable]="laskunTyyppiObservable" [laskunTuotteetObservable]="laskunTuotteetObservable" [paivitaValidaatiot]="paivitaValidaatiot"></app-lasku-rivit>

        <div>
          <table style="width: 100%; text-align: right">
            <tr style="font-size: 12px; color: rgb(153, 153, 153)">
              <td>
                {{ 'lasku.yhteensa-veroton' | translate | async }}
              </td>
              <td style="width: 150px; padding-right: 5px">
                {{ alvitonSumma | lmoney: kasiteltava?.valuutta | async }}
              </td>
            </tr>
            <tr style="font-size: 12px; color: rgb(153, 153, 153)">
              <td>
                {{ 'lasku.alv' | translate | async }}
              </td>
              <td style="padding-right: 5px">
                {{ alvSumma | lmoney: kasiteltava?.valuutta | async }}
              </td>
            </tr>
            @if (aiemminMaksettu) {
              <tr style="font-size: 12px; color: rgb(153, 153, 153)">
                <td>
                  {{ 'lasku.yhteensa-verollinen' | translate | async }}
                </td>
                <td style="padding-right: 5px">
                  {{ yhteensaSumma | lmoney: kasiteltava?.valuutta | async }}
                </td>
              </tr>
            }
            @if (aiemminMaksettu) {
              <tr style="font-size: 12px; color: rgb(153, 153, 153)">
                <td>
                  {{ 'lasku.aiemmin-maksettu-tuote' | translate | async }}
                </td>
                <td style="padding-right: 5px">
                  {{ aiemminMaksettu | lmoney: kasiteltava?.valuutta | async }}
                </td>
              </tr>
            }
            <tr style="font-size: 16px" class="light-blue-text">
              <td>
                {{ 'pdf-perinteinen.maksettava-yhteensa' | translate | async }}
              </td>
              <td style="padding-right: 5px">
                {{ yhteensaSumma + aiemminMaksettu | lmoney: kasiteltava?.valuutta | async }}
              </td>
            </tr>
          </table>
        </div>

        @if (asetuksissaOnOletustietojaVirhe) {
          <div class="red-text" style="margin-top: 4em">
            {{ 'lasku.validation.asetukset.oletuksia-print' | translate | async }}
          </div>
        }

        @if (hyvitysPositiivinenVirhe) {
          <div class="red-text" style="text-align: center; margin-top: 4em">
            {{ 'lasku.validation.hyvitys.ei-voi-olla-positiivinen' | translate | async }}
          </div>
        }

        <div class="lasku-container blue" style="margin-top: 40px">
          <div class="vasenp">
            <p>Laskun omistaja</p>
            <mat-form-field style="width: 200px; margin-right: 20px">
              <mat-label>Kirjanpitäjä</mat-label>
              <mat-select [formField]="lomake.tilastoKirjanpitaja" [compareWith]="compareKirjanpitajat">
                @for (kirjanpitaja of kirjanpitajienNimiTiedotObservable | async; track kirjanpitaja) {
                  <mat-option [value]="kirjanpitaja"> {{ kirjanpitaja.etunimi }} {{ kirjanpitaja.sukunimi }} </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 155px; margin-right: 20px">
              <mat-label>Tiimi</mat-label>
              <mat-select [formField]="lomake.tilastoTiimi" [compareWith]="compareTiimit">
                @for (tiimi of tiimitObservable | async; track tiimi) {
                  <mat-option [value]="tiimi">
                    {{ tiimi.nimi }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div style="margin-top: 4em; margin-bottom: 4em; text-align: center">
          @if (this.kasiteltava.nrotyyppi === 'h') {
            <app-primary-button (click)="saveAndPrint()" actionId="Lähetä lasku tulostamalla" styles="margin-right: .5em; margin-left: .5em; margin-top: 1em;">
              <span>Lähetä itse (lataa koneelle)</span>
            </app-primary-button>
          }
          @if (lahetaEmailinaObservable | async) {
            <app-primary-button (click)="saveAndSendEmail()" actionId="Avasi dialogin: Lähetä lasku sähköpostilla" styles="margin-right: .5em; margin-left: .5em; margin-top: 1em;">
              <span>{{ 'lasku.spostilahetys' | translate | async }}</span>
            </app-primary-button>
          }
          @if (lahetaSahkoisenaObservable | async) {
            <app-primary-button (click)="saveAndSendElectronic()" actionId="Lähetä lasku verkkolaskuna" styles="margin-right: .5em; margin-left: .5em; margin-top: 1em;">
              <span>Lähetä verkkolaskuna</span>
            </app-primary-button>
          }
        </div>
      </div>

      <div class="oikeap">
        <div style="margin: 14px 0; font-size: 15px" class="light-blue-text">{{ 'lasku.esikatselu.otsikko' | translate | async }}</div>
        <lasku-pdf-esikatselu-perinteinen [tiedot]="esikatselutiedot | async" [laskunLahetysPiilotaProjekti]="true"></lasku-pdf-esikatselu-perinteinen>
      </div>
    </div>
  </div>
</form>
